import React, { Component } from 'react'
import { Translate } from "react-localize-redux";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../store/reportStore';
import BbCheckbox from '../styling/bbCheckbox';
import CrossIcon from '../../img/icons/Cross';
import { reportNavActions } from '../../store/reportNavStore';
import './reportSectionsManager.scss';

class ReportSectionsPdfExport extends Component {
    render () {
        return (
            <article className="panel">
                <div className="panel-heading">
                    <div className='panel-heading-title'>
                        <div style={{marginRight:'auto', marginTop:'auto', marginBottom:'auto'}}><Translate id="Report.Sections.PdfExport" /></div>
                        <CrossIcon className='icon-centered' onClick={this.props.closePanel} style={{marginLeft: '.5em'}} />
                    </div>
                </div>
                <div className='search-progress'></div>
                <div className="panel-block report-sections-export-manager" style={{paddingTop:'calc(.5em + 3px)'}}>
                    {(this.props.nav.sectionMap || []).filter(x => x.hidden !== true).map(v => this.renderSectionItem(v))}
                    <hr className='divider' />
                    <div className='section-name-container'>
                        <h6 style={{paddingLeft: '.3em', fontSize: '.9em', marginBottom: '.25em', marginTop: '.25em'}}>
                            <Translate id='Report.Sections.PdfExport.Legend' />
                        </h6>
                    </div>
                    <div className='section-name-container' style={{pointerEvents:'none'}}>
                        <BbCheckbox label='' id='legeng-actual' value={true} onChange={() => {}} />
                        <span className='delimiting-span-2' />
                        <div className='section-header-wrapper'>
                            <h6 className='section-header'>
                                <Translate id='Report.Sections.PdfExport.ActualData' />
                            </h6>
                        </div>
                    </div>
                    <div className='section-name-container' style={{pointerEvents:'none'}}>
                        <BbCheckbox label='' id='legend-history' value={true} history={true} onChange={() => {}} />
                        <span className='delimiting-span-2' />
                        <div className='section-header-wrapper'>
                            <h6 className='section-header'>
                                <Translate id='Report.Sections.PdfExport.HistoryData' />
                            </h6>
                        </div>
                    </div>
                    <div className='section-name-container' style={{pointerEvents:'none'}}>
                        <BbCheckbox label='' id='legend-history' value={false} disabled={true} history={true} onChange={() => {}} />
                        <span className='delimiting-span-2' />
                        <div className='section-header-wrapper'>
                            <h6 className='section-header'>
                                <Translate id='Report.Sections.PdfExport.NoHistoryData' />
                            </h6>
                        </div>
                    </div>
                </div>
            </article>
        );
    }

    renderSectionItem = (section) => {
        return (
            <div className='section-name-container' title={section.name} key={section.id}>
                <BbCheckbox label="" id={`showHide-${section.id}`} value={section.inPdf} onChange={(val) => this.props.setSectionInPdf(section.id, val, val === false ? false : section.historyInPdf)} />
                <BbCheckbox label="" id={`pdfHistory-${section.id}`} value={section.hasHistory ? section.historyInPdf : false} disabled={!section.hasHistory} history={true} onChange={(val) => this.props.setSectionInPdf(section.id, val === true ? true : section.inPdf, val)} />
                <span className='delimiting-span-2' />
                <div className='section-header-wrapper'>
                    <h6 className='section-header'>
                        {section.countryFilter ? <span>{section.name} <sup>{section.countryFilter}</sup></span> : section.name}
                    </h6>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({ nav: state.reportNav }),
    dispatch => bindActionCreators({...reportActions, ...reportNavActions}, dispatch)
)(ReportSectionsPdfExport);
